export default __webpack_public_path__ + "static/media/petek.97cd93c9.png";